<template>
  <v-card tile>
    <v-row class="ma-0">
      <v-card-title><h2>Welcome to Clickwork</h2></v-card-title>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="8" class="pa-2">
        <v-card-text>
          <p>Please create your admin account</p>
          <v-form v-model="formValid" :disabled="loading">
            <v-text-field
              type="email"
              required
              label="Email address"
              filled
              :rules="[rules.required, rules.email]"
              v-model="email"
            ></v-text-field>
            <v-text-field
              type="password"
              required
              label="Password"
              filled
              :rules="[rules.required, rules.password]"
              v-model="password"
            ></v-text-field>
            <v-text-field
              type="password"
              required
              label="Confirm password"
              filled
              :rules="[
                rules.required,
                (v) => v === this.password || 'Passwords do not match',
                rules.password,
              ]"
              v-model="rePassword"
            ></v-text-field>
            <v-row
              align="center"
              justify="end"
              class="mb-0"
              style="max-height: 32px"
            >
              <p class="mr-2 terms">
                I have read and understood the
                <a href="https://clickwork.app/privacy-policy" target="_blank"
                  >Privacy Policy</a
                >
              </p>
              <v-checkbox class="ma-0" v-model="privacy"></v-checkbox>
            </v-row>
            <v-row
              align="center"
              justify="end"
              class="mt-0 mb-0"
              style="max-height: 32px"
            >
              <p class="mr-2 terms">
                I agree to the
                <a href="https://clickwork.app/terms-conditions" target="_blank"
                  >Terms and Conditions</a
                >
              </p>
              <v-checkbox class="ma-0" v-model="terms"></v-checkbox>
            </v-row>
          </v-form>
        </v-card-text>
      </v-col>
      <v-col cols="4" class="pa-2">
        <v-img
          :src="require('@/assets/images/img-registration-one@3x.png')"
          max-width="293px"
          max-height="342px"
        ></v-img>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="8" class="pa-2">
        <v-card-actions>
          <v-btn text color="primary" class="button" :to="{ name: 'login' }"
            >Sign in instead</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="button"
            :disabled="!canSubmit"
            :loading="loading"
            @click.prevent="submit"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { textFieldRules } from '@/common'
import { auth } from '@/firebaseConfig'
import { mapActions } from 'vuex'

export default {
  data: () => ({
    formValid: false,
    loading: false,
    email: null,
    password: null,
    rePassword: null,
    privacy: false,
    terms: false,
    rules: textFieldRules,
  }),
  computed: {
    canSubmit() {
      return (
        this.formValid &&
        this.password === this.rePassword &&
        this.privacy === true &&
        this.terms === true
      )
    },
  },
  methods: {
    ...mapActions(['showError']),
    async submit() {
      try {
        this.loading = true
        await auth.createUserWithEmailAndPassword(this.email, this.password)
        const user = auth.currentUser
        await user.sendEmailVerification()

        this.$emit('registration:complete', user)
      } catch (error) {
        console.error(error)
        this.showError(
          error.message ?? 'Failed top create user, please try again'
        )
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.terms
  @include sectionTitle
a
  @incliude tabActive
    color: $primary
</style>
